import styled from "styled-components";
import { ButtonBase } from "../elements";

export const BackButton = styled(ButtonBase) <{ color?: string }>`
    display: flex;
    align-items: center;
    font-size: 14px;
    background: ${props => props.color};
    border-radius: 30px;
    height: 40px;
    padding: 0 10px;
`;
